var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from 'prop-types';
// import isDate from 'lodash/isDate'

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';

// THESE ARE JUST DEMO HELPERS - not needed in a real form
var getFieldName = function getFieldName(f) {
	return f.aliasName || f.name;
};
var getDisplayName = function getDisplayName(f) {
	return f.displayName || f.aliasName || f.name;
};
var getInputType = function getInputType(field) {
	var inputType = field.inputType;
	if (inputType) {
		return inputType === 'datetime' ? 'datetime-local' : inputType;
	}

	var type = field.dataType;
	var v = field.validation || {};

	if (/(string)/.test(type)) return 'text';
	if (/(boolean)/.test(type)) return 'checkbox';
	if (/(number|integer)/.test(type) || v.number || v.integer) return 'number';
	if (/datetime/.test(type) || v.datetime) return 'datetime-local';
	if (/date/.test(type) || v.date) return 'date';
	if (/time/.test(type) || v.time) return 'time';
	if (v.email) return 'email';
	if (v.password) return 'password';
	return 'text';
};

var helperTextStyles = {
	root: {
		whiteSpace: 'pre-line', // Puts each error-message on its own line
		lineHeight: '1.3em',
		display: 'none' // Hide blocks when not in error-state
	},
	error: {
		display: 'block'
	}

	/**
  * Sample output of fields to validate form config
  */
};
var FieldsTestOutput = function (_React$Component) {
	_inherits(FieldsTestOutput, _React$Component);

	function FieldsTestOutput(props) {
		_classCallCheck(this, FieldsTestOutput);

		var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

		_this.focusField = React.createRef();
		return _this;
	}

	FieldsTestOutput.prototype.componentDidMount = function componentDidMount() {
		// Auto-focus a field on-mount, if one passed in props
		var elem = this.focusField.current;
		if (elem) elem.focus();
	};

	FieldsTestOutput.prototype.render = function render() {
		var _this2 = this;

		var props = this.props;
		var form = props.form,
		    classes = props.classes;


		var formFields = form.getFieldConfig();
		// Transform hash to array for easy looping below
		// NOTE: Object.values() is not as supported as Object.keys()
		var arrFields = Object.keys(formFields).map(function (fieldName) {
			return formFields[fieldName];
		});

		var style = {
			border: '1px solid #CCC',
			borderRadius: '4px',
			margin: '24px',
			padding: '16px'
		};
		if (props.style) {
			Object.assign(style, props.style);
		}

		return React.createElement(
			'section',
			{ style: style },
			React.createElement(
				Typography,
				{ variant: 'title' },
				'Autogenerated Field Output',
				React.createElement('span', { className: 'field-required-mark' })
			),
			React.createElement(
				Typography,
				{ paragraph: true, className: 'form-tip' },
				'This tool can be used to verify data, field-configuration and validation options.'
			),
			React.createElement(
				'section',
				null,
				React.createElement(
					Button,
					{
						color: 'primary',
						variant: 'contained',
						style: { margin: '10px 0 10px 10px' },
						onClick: form.validateAll
					},
					'Validate All'
				),
				React.createElement(
					Button,
					{
						color: 'secondary',
						variant: 'contained',
						style: { margin: '10px 0 10px 10px' },
						onClick: form.reset
					},
					'Reset Form'
				)
			),
			React.createElement('hr', null),
			arrFields.map(function (field) {
				var aliasName = getFieldName(field);
				var displayName = getDisplayName(field);
				var inputType = getInputType(field);
				var ref = aliasName === props.focus ? _this2.focusField : null;

				// NEVER set a value to Null or Undefined, because this
				var value = form.getValue(aliasName);

				if (inputType === 'checkbox') {
					return React.createElement(
						FormControl,
						{
							key: aliasName,
							fullWidth: true,
							margin: 'dense',
							error: form.hasErrors(aliasName)
						},
						React.createElement(FormControlLabel, {
							label: displayName,
							control: React.createElement(Checkbox, _extends({}, form.dataProps(aliasName, { checkbox: true }), {
								color: 'primary',
								inputRef: ref
							}))
						}),
						React.createElement(
							FormHelperText,
							{ classes: classes },
							form.getErrors(aliasName)
						)
					);
				} else {
					return React.createElement(TextField, _extends({
						key: aliasName,
						label: displayName
					}, form.dataProps(aliasName), form.errorProps(aliasName), {
						value: value,
						type: inputType,
						fullWidth: true,
						margin: 'dense',
						inputRef: ref,
						FormHelperTextProps: { classes: classes }
					}));
				}
			}),
			props.submitForm && React.createElement(
				Typography,
				{ paragraph: true, className: 'form-tip' },
				React.createElement(
					Button,
					{ color: 'primary', onClick: props.submitForm },
					'Save / Submit'
				)
			)
		);
	};

	return FieldsTestOutput;
}(React.Component);

var func = PropTypes.func,
    string = PropTypes.string,
    object = PropTypes.object;


FieldsTestOutput.propTypes = process.env.NODE_ENV !== "production" ? {
	focus: string,
	submitForm: func,
	classes: object
} : {};

export default withStyles(helperTextStyles)(FieldsTestOutput);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@allpro/form-manager/es/tools/FieldsTestOutput.js
// module id = 545
// module chunks = 0